import { makeStyles } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { getLargeDrawerPaperStyles } from 'UI/constants/styles';

export const useDrawerStyles = makeStyles(theme => ({
  drawerLarge: {
    ...getLargeDrawerPaperStyles(theme),
    overflowY: 'hidden'
  }
}));

export const ScopeSelectorContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(3),
  width: '40%',
  [theme.breakpoints.down('sm')]: {
    width: '90%'
  }
}));
